import React from 'react';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import RenderBlockAsset from './RenderBlockAsset';
import RenderBlockEntry from './RenderBlockEntry';
import RenderInlineEntry from './RenderInlineEntry';

export const enhancedTextRenderers = {
  /* eslint-disable react/display-name */
  [BLOCKS.EMBEDDED_ASSET]: ({ data }) => <RenderBlockAsset asset={data.target} />,
  [BLOCKS.EMBEDDED_ENTRY]: ({ data }) => <RenderBlockEntry entry={data.target} />,
  [INLINES.EMBEDDED_ENTRY]: ({ data }) => <RenderInlineEntry entry={data.target} />
  /* eslint-enable react/display-name */
};
